import { NameIdOption } from "../../../../common/types/commonTypes";

export const handleAutocompleteChange = (
  newValue: NameIdOption | NameIdOption[] | null,
  onChange: ((value: NameIdOption[] | null) => void) | undefined,
  multiple: boolean,
) => {
  if (!onChange) return;

  if (multiple) {
    // For multiple selection: always return an array
    onChange(Array.isArray(newValue) ? newValue : newValue ? [newValue] : null);
  } else {
    // For single selection: extract single value but still return as array for consistency
    const singleValue = Array.isArray(newValue)
      ? newValue[0] || null
      : newValue;
    onChange(singleValue ? [singleValue] : null);
  }
};
